module.exports = __webpack_public_path__ + "assets/images/MAIL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/MAIL.png
// module id = 1419
// module chunks = 1